import PanelStatCard from '../shared/PanelStatCard';

export default PanelStatCard;
